import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

import { termTitleSelector, userSelector } from 'app-redux/selectors'

/**
 * @description use https://www.npmjs.com/package/pluralize
 * if the english term is can be change from user
 *
 * @param formatMessage
 * @returns {{reference: string, product: string, vendor: string, tag: string, customer: string}}
 */
export const getPluralize = ({ formatMessage }) => ({
  customer: `${formatMessage({ id: 'report.customer' })}s`,
  tag: `${formatMessage({ id: 'financeTag.financeTag' })}s`,
  reference: `${formatMessage({ id: 'report.reference' })}s`,
  vendor: `${formatMessage({ id: 'report.vendor' })}s`,
  product: `${formatMessage({ id: 'report.product' })}s`,
  sales_person: formatMessage({ id: 'salesPerson.sales_person' }),
  payable: formatMessage({ id: 'creditMemo.credit_memo' }),
  receivable: formatMessage({ id: 'debitMemo.debit_memo' }),
})

export const getTerm = ({ formatMessage, term, plural }) => {
  if (plural) {
    return getPluralize({ formatMessage })
  }

  return {
    customer: term?.customer ?? formatMessage({ id: 'report.customer' }),
    tag: term?.tag ?? formatMessage({ id: 'financeTag.financeTag' }),
    reference: term?.reference ?? formatMessage({ id: 'report.reference' }),
    vendor: term?.vendor ?? formatMessage({ id: 'report.vendor' }),
    product: term?.product ?? formatMessage({ id: 'report.product' }),
    sales_person: term?.sales_person ?? formatMessage({ id: 'salesPerson.sales_person' }),
    payable: term?.payable ?? formatMessage({ id: 'creditMemo.credit_memo' }),
    receivable: term?.receivable ?? formatMessage({ id: 'debitMemo.debit_memo' }),
  }
}

const useTerm = ({ plural } = {}) => {
  const { formatMessage } = useIntl()
  const term = useSelector(termTitleSelector)
  const user = useSelector(userSelector)

  return getTerm({ formatMessage, term, plural: plural && user?.lang === 'en-US' })
}

export default useTerm
